


































import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import draggable from "vuedraggable";
import LibTreeItem from "@/components/Library/LibTreeItem.vue";
import NavNode from "@/services/NavigationNode";

import uid from "@/utils/uid";

@Component({
	components: {
		draggable,
		LibTreeItem
	}
})
export default class Library extends Vue {
	@Prop({default: () => []}) items!: NavNode[];
	@Prop({ default: false }) ro!: boolean;

	cloned(e: NavNode) {
		const a = JSON.parse(JSON.stringify(e)); // cloning of a deep object, grrr...
		a.isRootNode = true;
		uid([a]);
		this.$store.dispatch("setSelected", a.uid);
		return a;
	}
}
